import { PayrollType } from './../entities/payroll-type';
import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng'; 
import { catchError, tap, map } from 'rxjs/operators';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { CostCenter } from '../entities/costCenter';
import { EmployeeFile } from '../entities/employee-file';
import { EmployeeTtype } from '../entities/employeeTtype';
import { ExecutingUnit } from '../entities/executingUnit';
import { Addendum } from '../model/addendum';
import { SpinnerService } from './spinner.service';
import { BaseService } from '../../shared/_utils/services/base-service';
import { Observable } from 'rxjs/Observable';
import { FiscalYear } from '../entities/fiscalYear';
import { IncomeTaxEmployee } from '../model/income-tax-employee';
import { Hhelpdesk } from '../entities/hhelpdesk';
import * as FileSaver from 'file-saver';
import { MassiveEmployee } from '../model/import-employee';

interface ExtraSearchFields {
  code?: string,
  firstLastName?: string,
  secondLastName?: string,
  name?: string,
  executingUnit?: ExecutingUnit,
  costCenter?: CostCenter,
  employeeType?: EmployeeTtype,
  startDateRange01?: Date,
  startDateRange02?: Date,
  startContractDateRange01?: Date,
  startContractDateRange02?: Date,
  hasTerminationDate?: boolean,
  fiscalYear?: FiscalYear,
  month?: Hhelpdesk ,
  payrollType ? : PayrollType
}

@Injectable()
export class EmployeeFileService extends BaseService {

  uri = '/api/employeeFile/';

  constructor(injector: Injector, spinnerService: SpinnerService) {
    super(injector);
   //console.log('Instance EmployeeFileService');
  }

  buildSentence(entity?: EmployeeFile, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
    if (entity || extraSearchFields) {
      let query = '';
      query = query.concat(
        extraSearchFields && extraSearchFields.code ?
          `code${QueryOperator.Equal}${extraSearchFields.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.firstLastName ?
          `firstLastName${QueryOperator.Contain}${extraSearchFields.firstLastName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.secondLastName ?
          `secondLastName${QueryOperator.Contain}${extraSearchFields.secondLastName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.name ?
          `name${QueryOperator.Contain}${extraSearchFields.name}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.executingUnit ?
          `executingUnit.id${QueryOperator.Equal}${extraSearchFields.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.fiscalYear ?
          `fiscalYear.id${QueryOperator.Equal}${extraSearchFields.fiscalYear.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.costCenter ?
          `costCenter.id${QueryOperator.Equal}${extraSearchFields.costCenter.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.costCenter ?
          `costCenterDesignation.id${QueryOperator.Equal}${extraSearchFields.costCenter.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.employeeType ?
          `employeeType.id${QueryOperator.Equal}${extraSearchFields.employeeType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.startDateRange01 && extraSearchFields.startDateRange02 ?
          // tslint:disable-next-line:max-line-length
          `startDate${QueryOperator.Between}${extraSearchFields.startDateRange01.toISOString()}${QueryOperator.Slash}${extraSearchFields.startDateRange02.toISOString()}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.startContractDateRange01 && extraSearchFields.startContractDateRange02 ?
          // tslint:disable-next-line:max-line-length
          `startContractDate${QueryOperator.Between}${extraSearchFields.startContractDateRange01.toISOString()}${QueryOperator.Slash}${extraSearchFields.startContractDateRange02.toISOString()}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.hasTerminationDate === true || extraSearchFields.hasTerminationDate === false ?
          `terminationDate${extraSearchFields.hasTerminationDate ? QueryOperator.IsNull : QueryOperator.IsNotNull}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.month ?
          `month.id${QueryOperator.Equal}${extraSearchFields.month.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.payrollType ?
          `payrollType.id${QueryOperator.Equal}${extraSearchFields.payrollType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
     //console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  search(entity?: EmployeeFile, event?: LazyLoadEvent,
    extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<EmployeeFile>> {

    const url = `${this.rutaServidor}${this.uri}search`;
    this.spinnerService.showAll();
    const httpParams = this.buildSentence(entity, event, extraSearchFields);
    return this.httpClient.get<ResponsePageable<EmployeeFile>>(url, { params: httpParams })
      .pipe(
        tap(response => {
          if (response.numberOfElements > 0) {
            response.content.forEach((value) => {
              // debugger;
              this.convertToDate(value);
            })
          }
         //console.log('response search check here');
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  getOneByCode(code: string | number): Observable<EmployeeFile> {
    // debugger;
    const url = this.rutaServidor + this.uri + 'code/' + code;
    this.spinnerService.showAll();
    return this.httpClient.get<ResponsePageable<EmployeeFile>>(url)
      .pipe(
        tap((response: ResponsePageable<EmployeeFile>) => {
         //console.log(response);
          if (response.numberOfElements > 0) {
            this.convertToDate(response.content[0]);
          }
          this.spinnerService.hideAll();
        }),
        map((response: ResponsePageable<EmployeeFile>) => response.content[0])
      );
  }

  validateAddendum(importAddendum: Addendum[]) {
    const url = `${this.rutaServidor}${this.uri}addendum/`;
    this.spinnerService.showAll();
    this.httpParams = this.httpParams.set(QueryOperator.Action, 'validate');
    return this.httpClient.post<Addendum[]>(url, importAddendum, { params: this.httpParams })
      .pipe(
        tap(response => {
          this.spinnerService.hideAll();
        })
      );
  }

  createAddendum(importAddendum: Addendum[]) {
    const url = `${this.rutaServidor}${this.uri}addendum/`;
    this.spinnerService.showAll();
    this.httpParams = this.httpParams.set(QueryOperator.Action, 'create');
    return this.httpClient.post<Addendum[]>(url, importAddendum, { params: this.httpParams })
      .pipe(
        tap(response => {
          this.spinnerService.hideAll();
        })
      );
  }

  getTreeNode5taByEmployee(fiscalYearId: number, euId: number, employeeId: number, monthId: number , arrayEntrys : any):Observable<any>{
   //console.log(arrayEntrys);
    const rutaServidor = localStorage.getItem('rutaServidor');
   //console.log("rutaServidor :" + rutaServidor);
    const url =  rutaServidor + '/api/employeeFile/treeNode5ta'; 
   //console.log("url :" + url);
    return this.httpClient.get(url+"?fiscalYearId="+fiscalYearId
                                  + "&euId="+ euId
                                  + "&employeeId="+ employeeId
                                  + "&monthId="+ monthId
                                  + "&arrayEntrys="+arrayEntrys);
  }

  getTreeNodeAnnualIncome(fiscalYearId: number, euId: number, employeeId: number, arrayEntrys: any): Observable<any>{
   //console.log(arrayEntrys);
    const rutaServidor = localStorage.getItem('rutaServidor');
   //console.log('rutaServidor :' + rutaServidor);
    const url = rutaServidor + '/api/employeeFile/treeNodeAnnualIncome';
   //console.log(url);
    return this.httpClient.get(url+"?fiscalYearId="+fiscalYearId
                                  + "&euId="+ euId
                                  + "&employeeId="+ employeeId
                                  + "&arrayEntrys="+arrayEntrys);
  }

  getIncomeTaxByEmployee(fiscalYearId: number, euId: number, monthId: number, employeeTypeId: number, employeeId: number){
    const rutaServidor = localStorage.getItem('rutaServidor');
   //console.log("rutaServidor :" + rutaServidor);
    const url =  rutaServidor + '/api/employeeFile/incomeTax'; 
   //console.log("url :" + url);
    return this.httpClient.get<IncomeTaxEmployee[]>(url+"?fiscalYearId="+fiscalYearId
                                  + "&euId="+ euId
                                  + "&monthId="+ monthId
                                  + "&employeeTypeId="+ employeeTypeId
                                  + "&employeeId="+ employeeId);
  }

  payrollSearch(entity?: EmployeeFile, event?: LazyLoadEvent,
    extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<EmployeeFile>> {

    const url = `${this.rutaServidor}${this.uri}payrollSearch`;
    this.spinnerService.showAll();
    const httpParams = this.buildSentence(entity, event, extraSearchFields);
    return this.httpClient.get<ResponsePageable<EmployeeFile>>(url, { params: httpParams })
      .pipe(
        tap(response => {
          if (response.numberOfElements > 0) {
            response.content.forEach((value) => {
              // debugger;
              this.convertToDate(value);
            })
          }
         //console.log('response search check here');
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  downloadExcel(url:string ,object: any , nameFile : string): Observable<Blob> {
    let ruta = this.rutaServidor + this.uri   +  url;
    //console.log("ruta : "  + ruta);
     this.spinnerService.showAll(); 
    return this.httpClient.post(ruta, object, {responseType: 'blob' })
        .pipe( 
            map(res =>  {   
                this.spinnerService.hideAll();
                let bean = new Blob([res],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                FileSaver.saveAs(bean, nameFile);
                return bean;
            }),
            catchError((err, caught) => { 
                //console.log("catchError : "  + catchError);
                this.spinnerService.hideAll(); 
                this.notificationService.serverErrorMessage(err.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
                return new Observable<Blob>();
            }) 
             
        ); 

}

validateMassiveEmployee(massiveEmployee: MassiveEmployee[],massiveType: string) {
  const url = `${this.rutaServidor}${this.uri}massiveEmployee/`;
  this.spinnerService.showAll();
  this.httpParams = this.httpParams.set('massiveType', massiveType);
  this.httpParams = this.httpParams.set(QueryOperator.Action, 'validate');
  return this.httpClient.post<MassiveEmployee[]>(url, massiveEmployee, { params: this.httpParams })
    .pipe(
      tap(response => {
        this.spinnerService.hideAll();
      })
    );
}

createMassiveEmployee(massiveEmployee: MassiveEmployee[],massiveType: string) {
  const url = `${this.rutaServidor}${this.uri}massiveEmployee/`;
  this.spinnerService.showAll();
  this.httpParams = this.httpParams.set('MassiveType', massiveType);
  this.httpParams = this.httpParams.set(QueryOperator.Action, 'create');
  return this.httpClient.post<MassiveEmployee[]>(url, massiveEmployee, { params: this.httpParams })
    .pipe(
      tap(response => {
        this.spinnerService.hideAll();
      })
    );
}

updateMassiveEmployee(massiveEmployee: MassiveEmployee[],massiveType: string) {
  const url = `${this.rutaServidor}${this.uri}massiveEmployee/`;
  this.spinnerService.showAll();
  this.httpParams = this.httpParams.set('MassiveType', massiveType);
  this.httpParams = this.httpParams.set(QueryOperator.Action, 'update');
  return this.httpClient.post<MassiveEmployee[]>(url, massiveEmployee, { params: this.httpParams })
    .pipe(
      tap(response => {
        this.spinnerService.hideAll();
      })
    );
}
downloadCSV(url: string, object: any, nameFile: string): Observable<Blob> {
  const ruta = this.rutaServidor + this.uri + url;

  this.spinnerService.showAll();

  return this.httpClient.post(ruta, object, { responseType: 'blob' })
    .pipe(
      map(res => {
        this.spinnerService.hideAll();
        const blob = new Blob([res], { type: 'text/csv;charset=utf-8' });
        FileSaver.saveAs(blob, nameFile);
        return blob;
      }),
      catchError(err => {
        this.spinnerService.hideAll();
        this.notificationService.serverErrorMessage(
          err.status + ' - Ocurrió un error. Por favor, inténtelo nuevamente más tarde.'
        );
        return new Observable<Blob>();
      })
    );
}


}



// WEBPACK FOOTER //
// ./src/app/core/services/employee-file.service.ts